'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var cookies = require('pobble-components/dist/cookies');
var setup = require('pobble-components/dist/setup');

var goToLesson = function goToLesson(id) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$showLastSlide = _ref.showLastSlide,
      showLastSlide = _ref$showLastSlide === void 0 ? false : _ref$showLastSlide;

  if (showLastSlide) cookies.LP_SHOW_LAST_SLIDE.set(true);
  window.location.href = "".concat(setup.URLS.APP, "/lessons/lesson/").concat(id);
};

exports.goToLesson = goToLesson;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/pobble-components/dist/router/index.js